import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ButtonCommonTopNew } from "../../pages/Theme";

const TaskReorderModal = ({ tasks,selectedIndex, onClose, onSave }) => {
  const [items, setItems] = useState(tasks); // full list (deleted + non-deleted)

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    // reorder within the FULL items array
    const newItems = Array.from(items);
    const [movedTask] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, movedTask);

    setItems(newItems);
  };

  const handleSave = () => {
    let newSelectedIndex = selectedIndex;

    if (items[selectedIndex]) {
      // get the actual task reference that was selected before reorder
      const selectedTask = tasks[selectedIndex];

      // find its new position in the reordered array
      newSelectedIndex = items.findIndex(
        (t) => t === selectedTask
      );
    }

    if (onSave) {
      onSave(items, newSelectedIndex); // send both reordered items + updated index
    }
    if (onClose) {
      onClose();
    }
  };


  return (
    <div className="pt-2 rounded-lg">
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="tasks">
          {(provided, snapshot) => (
            <ul
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={`space-y-2 transition-colors ${
                snapshot.isDraggingOver ? "" : "cardBackgroundColor"
              }`}
            >
              {items.map((task, index) =>
                task.is_deleted ? (
                  // keep placeholder in DOM but hidden (preserves index)
                  <div
                    key={index}
                    className="hidden"
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={null}
                  />
                ) : (
                  <Draggable
                    key={index.toString()}
                    draggableId={index.toString()}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <li
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={`p-4 rounded-md cursor-grab active:cursor-grabbing flex items-center text-sm font-medium
                          ${
                            snapshot.isDragging
                              ? "blueBackGroundColorDraggable border shadow-lg scale-105 rotate-2"
                              : "grayBackGroundColorNonDraggable border shadow-sm transition-colors duration-150"
                          }`}
                      >
                        <span
                          className={`${
                            snapshot.isDragging ? "text-white" : "blackColor"
                          } mr-3 text-lg`}
                        >
                          ⋮⋮
                        </span>
                        <span
                          className={`text-sm mt-0.5 ${
                            snapshot.isDragging ? "text-white" : "blackColor"
                          }`}
                        >
                          {task.task_name}
                        </span>
                      </li>
                    )}
                  </Draggable>
                )
              )}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>

      <div className="pt-4 flex items-center justify-center">
        <ButtonCommonTopNew
          className="px-5 border p-2 text-sm rounded-lg cursor-pointer"
          onClick={handleSave}
        >
          Update
        </ButtonCommonTopNew>
      </div>
    </div>
  );
};

export default TaskReorderModal;
